import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimesInfoTopBarComponent } from './times-info-top-bar.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '@swimlane/ngx-charts';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { TaskViewModalModule } from '../task-view-modal/task-view-modal.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'primeng/api';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { TimesInfoTopBarCardComponent } from '../times-info-top-bar-card/times-info-top-bar-card.component';



@NgModule({
  declarations: [TimesInfoTopBarComponent, TimesInfoTopBarCardComponent],
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    InputMaskModule,
    InputNumberModule,
    TooltipModule,
    InfiniteScrollModule,
    TranslateModule,
    PipesModule,
    WidgetModule
  ],
  exports:[TimesInfoTopBarComponent]
})
export class TimesInfoTopBarModule { }
